// Datos y lógica de dominio del selector de plantillas de informe (solo frontend,
// prototipo). Compartido por el orquestador, la galería y el detalle/customizer.
// Pendiente: sustituir los datos demo (project/sections) por los reales del proyecto.

// Claves canónicas (deben coincidir con REPORT_TEMPLATES del builder). `info` describe la
// plantilla para el modal de información (columnas/líneas con el nombre real del informe, EN).
export const templates = {
  weekly: {
    name: 'Semanal', reco: true, locked: false,
    desc: 'Base completa: portada, dashboard (grupos padre), gráficos por grupo, GENERAL, disciplinas, tabla y Gantt.',
    cover: true, rag: true, tasks: true, gantt: true, ganttOrient: 'portrait',
    sections: { OC: true, MM: true, ME: true, LEV: false, SET: true, BESS: false },
    chips: ['Grupos: padre', 'Curva S: 2 líneas', 'GENERAL ×6', 'Disciplina ×4'],
    info: {
      groupMode: 'parent', generalImages: 6, disciplineImages: 4,
      scurveLines: ['Scheduled', 'Current'],
      taskColumns: ['Schedule Date', 'Current progress %', 'Current progress (unit)', 'Project scheduled %'],
      disciplines: ['OC', 'MM', 'ME', 'SET'], gantt: true, ganttImages: 2,
    },
  },
  weekly_children: {
    name: 'Semanal · subgrupos', reco: false, locked: false,
    desc: 'Como la Semanal pero el dashboard muestra subgrupos y la tabla añade las fechas reales (Actual).',
    cover: true, rag: true, tasks: true, gantt: true, ganttOrient: 'portrait',
    sections: { OC: true, MM: true, ME: true, LEV: false, SET: true, BESS: false },
    chips: ['Grupos: subgrupos', '+ Actual', 'Curva S: 2 líneas'],
    info: {
      groupMode: 'children', generalImages: 6, disciplineImages: 4,
      scurveLines: ['Scheduled', 'Current'],
      taskColumns: ['Schedule Date', 'Actual', 'Current progress %', 'Current progress (unit)', 'Project scheduled %'],
      disciplines: ['OC', 'MM', 'ME', 'SET'], gantt: true, ganttImages: 2,
    },
  },
  weekly_extended: {
    name: 'Semanal · extendida', reco: false, locked: false,
    desc: 'Semanal con curva S de 3 líneas (programado, ejecutado y última programada) y tabla ampliada.',
    cover: true, rag: true, tasks: true, gantt: true, ganttOrient: 'portrait',
    sections: { OC: true, MM: true, ME: true, LEV: false, SET: true, BESS: false },
    chips: ['Grupos: padre', 'Curva S: 3 líneas', 'Tabla ampliada'],
    info: {
      groupMode: 'parent', generalImages: 6, disciplineImages: 4,
      scurveLines: ['Scheduled', 'Current', 'Last planned'],
      taskColumns: ['Schedule Date', 'Actual', 'Current progress %', 'Project scheduled %'],
      disciplines: ['OC', 'MM', 'ME', 'SET'], gantt: true, ganttImages: 2,
    },
  },
  executive: {
    name: 'Ejecutivo', reco: false, locked: false,
    desc: 'Para dirección: portada, dashboard (grupos padre), gráficos por grupo e imágenes.',
    cover: true, rag: true, tasks: false, gantt: false, ganttOrient: 'portrait',
    sections: { OC: false, MM: false, ME: false, LEV: false, SET: false, BESS: false },
    chips: ['Grupos: padre', 'Curva S: 2 líneas', 'GENERAL'],
    info: {
      groupMode: 'parent', generalImages: 4,
      scurveLines: ['Scheduled', 'Current'],
      gantt: false,
    },
  },
  custom: {
    name: 'Personalizada', reco: false, locked: false,
    desc: 'La única editable: empieza con lo básico (portada y dashboard) y añade lo que necesites.',
    cover: true, rag: true, tasks: false, gantt: false, ganttOrient: 'portrait',
    sections: { OC: false, MM: false, ME: false, LEV: false, SET: false, BESS: false },
    chips: ['Portada', 'Dashboard', '+ añadir'],
  },
}

export const reportTypes = [
  { id: 'detailed', name: 'Informe detallado', available: true },
  { id: 'executive', name: 'Informe ejecutivo', available: false },
  { id: 'incidents', name: 'Informe de incidencias', available: false },
]

export const sections = [
  { code: 'OC', name: 'Obra civil', type: 'standard2' },
  { code: 'MM', name: 'Instalación mecánica', type: 'mechanical' },
  { code: 'ME', name: 'Instalación eléctrica', type: 'standard2' },
  { code: 'LEV', name: 'Línea de evacuación', type: 'lev' },
  { code: 'SET', name: 'Subestación (SET)', type: 'standard2' },
  { code: 'BESS', name: 'BESS', type: 'standard2' },
]

// Datos demo del mockup (x-elio · proyecto 960). Se reemplazarán por los reales.
export const project = {
  company: 'Nombre de la empresa', name: 'Nombre del proyecto', weekNum: '31',
  week: '31 · 27-07-2026 → 02-08-2026', overall: '42.1%',
}

export const pictoStatuses = [
  { n: 'En ejecución', c: '#e5a94a' }, { n: 'Ejecutado', c: '#2456d6' },
  { n: 'Rechazado', c: '#c23b4a' }, { n: 'Liberado', c: '#15926a' },
]

// Copia superficial de una plantilla al estado editable `st`.
export function cloneTemplate(t) {
  return {
    name: t.name, cover: t.cover, rag: t.rag, tasks: t.tasks,
    gantt: t.gantt, ganttOrient: t.ganttOrient, sections: { ...t.sections },
  }
}

// Construye la lista de páginas (estructura real del PDF) a partir de un estado st.
export function buildPages(st) {
  const P = []
  if (st.cover) P.push({ cap: 'Portada', kind: 'cover' })
  if (st.rag) {
    P.push({ cap: 'Dash', kind: 'dashboard' })
    P.push({ cap: 'Gráf.', kind: 'groupcharts' })
    P.push({ cap: 'General', kind: 'images', title: 'General — imágenes' })
  }
  sections.forEach(s => {
    if (!st.sections[s.code]) return
    if (s.type === 'mechanical') {
      P.push({ cap: s.code, kind: 'mm', sec: s })
      P.push({ cap: 'Curva S', kind: 'scurve', sec: s })
      P.push({ cap: 'Imág.', kind: 'images', title: s.name + ' — imágenes' })
      ;['Pilings', 'Estructuras', 'Módulos'].forEach(layer => P.push({ cap: layer.slice(0, 5), kind: 'pictogram', layer }))
    } else if (s.type === 'standard2') {
      P.push({ cap: s.code, kind: 'disc2', sec: s })
      P.push({ cap: 'Imág.', kind: 'images', title: s.name + ' — imágenes' })
    } else if (s.type === 'lev') {
      P.push({ cap: s.code, kind: 'lev', sec: s })
      P.push({ cap: 'Imág.', kind: 'images', title: s.name + ' — imágenes' })
    } else {
      P.push({ cap: s.code, kind: 'discipline', sec: s })
    }
  })
  if (st.tasks) P.push({ cap: 'Tabla', kind: 'tasktable' })
  if (st.gantt) P.push({ cap: 'Gantt', kind: 'gantt', landscape: st.ganttOrient === 'landscape' })
  return P
}

// Nº de páginas que generaría una plantilla (t tiene la misma forma que st).
export function pagesFor(t) {
  return buildPages(t).length
}

// Miniatura esquemática (3 columnas de líneas) para la tarjeta de galería.
export function galleryThumb(t) {
  const nsec = sections.filter(s => t.sections[s.code]).length
  const colA = (t.cover ? [{ t: true }] : []).concat([{}, { w: '80%' }])
  const colB = [{ t: true, w: '70%' }].concat(nsec ? [{}, { w: '60%' }] : [{ w: '50%' }])
  const colC = t.gantt ? [{ t: true, w: '50%' }, {}, { w: '85%' }] : [{}]
  return [colA, colB, colC]
}
